/**
 * 转移业务
 */
import React from 'react';
import { Input, Button, Row, Col, Icon, Tooltip, DatePicker } from 'antd';
import PageLayout from '../../ui/PageLayout';
import http from '../../../axios/http';
//加载中遮罩
import Loading from '../../ui/Loading';
import DictSelect from '../../ui/DictSelect';
//申请单编辑
import AgentApplyEdit from './AgentApplyEdit';
//申请表打印
import ApplicationPrint from '../transfer/ApplicationPrint';
//退单
import Chargeback from './Chargeback';
//订单记录详细
import AgentApplyRecord from './AgentApplyRecord';
//完成车辆过户
import ApplyTransferred from './ApplyTransferred';
//会员选择
import MemberSelect from '../../crm/member/MemberSelect';
//撤单
import ApplyAgentCancel from './AgentApplyCancel';
// 加载权限编码
import { global_data } from '../../ui/auth'


class AgentApplyIndex extends React.Component {

    columns = [{
        title: '申请单编号',
        dataIndex: 'applicationId',
        width: '7%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '12%',
    }, {
        title: '旧车牌',
        dataIndex: 'plateNo',
        width: '7%',
    }, {
        title: '新车牌',
        dataIndex: 'newPlateNo',
        width: '7%',
    }, {
        title: '车型',
        dataIndex: 'brandModel',
        width: '14%',
    }, {
        title: '所属租户',
        dataIndex: 'memberName',
        width: '14%',
    }, {
        title: '申请时间',
        dataIndex: 'insertTime',
        width: '8%',
    }, {
        title: '提交人',
        dataIndex: 'creator',
        width: '6%',
    }, {
        title: '金额',
        dataIndex: 'actualComission',
        width: '6%',
    }, {
        title: '状态',
        dataIndex: 'statusStr',
        width: '8%',
    }, {
        title: '操作',
        dataIndex: 'id',
        width: '16%',
        render: (text, record, index) => (
            <div>
                {
                    (record.status === "draft" || record.status === "grabbing" || record.status === "grabbed" || record.status === "invoice")
                        || (this.state.authButton["APPLY_AGENT_ORDER_UPDATE"] && record.status !== "cancel") ?
                        <Tooltip title="修改基本信息">
                            <Icon type="edit" theme="filled" className="table-operate-icon" onClick={this.update.bind(this, record.applicationId)} />
                        </Tooltip>
                        : ""
                }
                <Tooltip title="打印申请表">
                    <Icon type="printer" theme="filled" className="table-operate-icon" onClick={this.printApplication.bind(this, record.applicationId)} />
                </Tooltip>
                <Tooltip title="详情">
                    <Icon type="eye" theme="filled" className="table-operate-icon" onClick={this.record.bind(this, record)} />
                </Tooltip>
                {
                        global_data.authCode.includes("APPLY_AGENT_ORDER_NEW")&&(record.status === "invoice" || record.status === "transferred") ?
                        <Tooltip title="完成过户录入新车牌号">
                            <Icon type="highlight" theme="filled" className="table-operate-icon" onClick={this.applyTransferred.bind(this, record)} />
                        </Tooltip>
                        : ""
                }
                {
                        global_data.authCode.includes("APPLY_AGENT_ORDER_RETURN")&&record.status === "grabbed" ?
                        <Tooltip title="退回待接单">
                            <Icon type="undo" className="table-operate-icon" onClick={this.chargeback.bind(this, record.applicationId)} />
                        </Tooltip>
                        : ""
                }
                {
                        global_data.authCode.includes("APPLY_AGENT_ORDER_CANCEL")&& record.status !== "draft" && record.status !== "cancel"?
                        <Tooltip title="撤单">
                            <Icon type="close-circle" theme="filled" className="table-operate-icon" onClick={this.cancel.bind(this, record.applicationId)} />
                        </Tooltip>
                        : ""
                }

            </div>
        ),
    }];

    state = {
        //编辑页面使用的数据信息
        editVisible: false,
        editData: {},

        //打印申请单页面使用的数据
        printVisible: false,
        printData: {},

        //退回申请单
        chargebackVisible: false,

        cancelVisible: false, //撤单

        //订单记录明细
        recordVisible: false,
        recordData: {},

        transferredVisible: false,

        applicationId: null, //当前在操作的数据
        newPlateNo: null, //当前操作的新车牌号

        queryData: {}, //查询数据
        loadingVisible: false,

        discount: 1, //过户代办费用折扣

        authButton: {}, //有权限的按钮
    };

    componentDidMount() {
        this.getAgentDiscount();
        //过户代办业务的编辑和撤单功能权限
        let authCodes = ["TRADE_APPLY_AGENT_EDIT", "TRADE_APPLY_AGENT_CANCEL"];
        let authButton = {};
        for (let i = 0; i < global_data.authCode.length; i++) {
            for (let j = 0; j < authCodes.length; j++) {
                if (global_data.authCode[i] === authCodes[j]) {
                    authButton[authCodes[j]] = true;
                }
            }
        }
        this.setState({ authButton: authButton });
    }

    getAgentDiscount = () => {
        http.get({
            url: '/tradeApplyAgent/getDiscount',
            success: (res) => {
                this.setState({ discount: res ? res : 1 });
            }
        });
    }


    add = () => {
        delete this.state.editData.image;
        let editData = {
            agent: 1, //新增时，默认是代办
            destination: '福建省厦门市',
            "buyer.creditType": 'P1',
            "seller.creditType": 'P1',
            "hasDiscount": 1
        };
        this.setState({
            editData: editData,
            editVisible: true
        });
        this.initEdit(editData);
    }

    update = (info, e) => {
        this.setState({ loadingVisible: true });
        http.post({
            url: '/tradeApplyAgent/getTradeApplyAgentDetail',
            data: { applicationId: info },
            success: (res) => {
                let application = res.application;
                let agent = res.agent;
                for (let key in agent) {
                    application[key] = agent[key];
                }
                if(agent.commission===0){
                    application.commission=null;
                }
                this.transferData(application, "buyer");
                this.transferData(application, "seller");
                this.transferData(application, "vehicle");
                this.transferData(application, "ticket");
                this.setState({ editData: application, editVisible: true, loadingVisible: false });
                this.initEdit(application);
            },
            error: (res) => {
                this.setState({ loadingVisible: false });
            }
        });
    }
    transferData = (res, field) => {
        let buyer = res[field];
        for (let key in buyer) {
            res[field + "." + key] = buyer[key];
        }
        delete res[field];
    }
    //打印申请单信息
    printApplication = (info, e) => {
        http.post({
            url: '/tradeApplyAgent/findPrintApplicationInfo',
            data: { applicationId: info },
            success: (res) => {
                this.setState({ printData: res, printVisible: true });
            }
        });
    }

    //将申请单退回到待接单状态
    chargeback = (info, e) => {
        this.setState({ chargebackVisible: true, applicationId: info });
    }
    //将申请单退回到待接单状态
    cancel = (info, e) => {
        this.setState({ cancelVisible: true, applicationId: info });
    }

    //单据的历史记录状态
    record = (info, e) => {
        http.get({
            url: '/tradeApplyAgent/findApplyRecord',
            data: { applicationId: info.applicationId },
            success: (res) => {
                info.list = res ? res : [];
                this.setState({ recordData: info, recordVisible: true });
            }
        });
    }

    //录入新的车牌信息
    applyTransferred = (info, e) => {
        this.setState({ "transferredVisible": true, "applicationId": info.applicationId, "newPlateNo": info.newPlateNo });
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.vinOrPlateNo = value
        this.loadData(queryData);
        this.setState({ queryData: queryData });
    }

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.loadData(queryData);
    }

    selectChange = (field, value) => {
        let queryData = this.state.queryData;
        queryData[field] = value;
        this.setState({ queryData: queryData });
        this.loadData(queryData);
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="车牌号/车架号"
                                    onSearch={this.inputSearch}
                                    enterButton
                                    style={{ width: '250px' }}
                                />
                                <DictSelect style={{ width: 120, marginLeft: '10px', marginRight: '10px' }} category="TRADE_AGENT_APPLY_STATUS"
                                    onChange={this.selectChange.bind(this, "status")} allowClear={true} />
                                <DatePicker.RangePicker onChange={this.rangePickerChange} style={{ margin: '0 10px' }} />
                                <MemberSelect onChange={this.selectChange.bind(this, "memberCode")} style={{ width: "200px" }} allowClear={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                {global_data.authCode.includes("APPLY_AGENT_ORDER_ADD")?
                                <Button type="primary" onClick={this.add}>新增</Button>
                                :""}
                            </Col>
                        </Row>
                    )}
                    rowKey="applicationId"
                    url="/tradeApplyAgent/pageTradeApplyAgent"
                    columns={this.columns}
                    loadData={(func) => { this.loadData = func }}
                />

                <AgentApplyEdit
                    visible={this.state.editVisible}
                    onCancel={() => { this.setState({ editVisible: false }) }}
                    editData={this.state.editData}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                    initFunc={(func) => { this.initEdit = func }}
                    discount={this.state.discount}
                />
                <ApplicationPrint
                    visible={this.state.printVisible}
                    onCancel={() => { this.setState({ printVisible: false }) }}
                    printData={this.state.printData}
                />
                <Chargeback
                    visible={this.state.chargebackVisible}
                    onCancel={() => { this.setState({ chargebackVisible: false }) }}
                    applicationId={this.state.applicationId}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                />
                <ApplyAgentCancel
                    visible={this.state.cancelVisible}
                    onCancel={() => { this.setState({ cancelVisible: false }) }}
                    applicationId={this.state.applicationId}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                />
                <ApplyTransferred
                    visible={this.state.transferredVisible}
                    onCancel={() => { this.setState({ transferredVisible: false }) }}
                    applicationId={this.state.applicationId}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                    plateNo={this.state.newPlateNo}
                />
                <AgentApplyRecord
                    visible={this.state.recordVisible}
                    editData={this.state.recordData}
                    onCancel={() => { this.setState({ recordVisible: false }) }}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="数据加载中"
                />
            </div>
        )
    }

}

export default AgentApplyIndex;